import React from 'react';
import { Box } from '@drivekyte/web-components';
import SectionHeader from '@/components/growth/section-header';
import useTranslation from '@/hooks/use-translation';
import SplitParagraph from '../split-paragraph';

const LocalTips = () => {
  const { t } = useTranslation('local-trips.local-tip');
  return (
    <Box
      marginTop="xxxLarge"
      marginLeft="medium"
      marginRight="medium"
      marginBottom="xxxLarge"
    >
      <SectionHeader
        tipText={t('tip')}
        primaryText={t('primary')}
        successText={t('success')}
        noMargin
      />
      <SplitParagraph>{t('caption')}</SplitParagraph>
    </Box>
  );
};

export default LocalTips;
